document.addEventListener("DOMContentLoaded", function () {
  console.log("Quickbuy script loaded!"); // Bekræfter at scriptet kører

  // Opdater variant-id på knappen, når en variant vælges
  document.body.addEventListener("change", function (event) {
    let variantSelect = event.target.closest(".variant-select");
    if (variantSelect) {
      event.preventDefault(); // Stopper Shopify fra at navigere væk
      event.stopPropagation();

      let productId = variantSelect.getAttribute("data-product-id");
      let selectedVariantId = variantSelect.value;

      let addToCartBtn = document.querySelector(
        `.quick-add-to-cart-btn[data-product-id="${productId}"]`
      );
      if (addToCartBtn) {
        addToCartBtn.setAttribute("data-variant-id", selectedVariantId);
        console.log(
          `✅ Variant opdateret for produkt ${productId}: ${selectedVariantId}`
        );
      } else {
        console.error("❌ Kunne ikke finde knappen for produktet.");
      }
    }
  });

  // Håndter klik på "Tilføj" knappen og send den valgte variant til Shopify's cart API
  document.body.addEventListener("click", function (event) {
    let quickAddBtn = event.target.closest(".quick-add-to-cart-btn");

    if (quickAddBtn) {
      event.preventDefault();
      let variantId = quickAddBtn.getAttribute("data-variant-id");

      if (!variantId) {
        console.error(
          "❌ Variant ID mangler! Standard variant bruges i stedet."
        );
        return;
      }

      console.log(`🛒 Forsøger at tilføje variant ${variantId} til kurven...`);

      let formData = {
        id: variantId,
        quantity: 1,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("✅ Produkt tilføjet til kurven:", data);
          document.dispatchEvent(new CustomEvent("theme:open-cart-drawer"));
          document.dispatchEvent(new CustomEvent("theme:cartchanged"));
        })
        .catch((error) => {
          console.error("❌ Fejl ved tilføjelse til kurv:", error);
        });
    }
  });
});
